
// You can write more code here

/* START OF COMPILED CODE */

import DecorationImage from "../DecorationImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DecorationBranch extends DecorationImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 99, y ?? 47.5, texture || 'game-all', frame ?? "branch.png");

    // this (prefab fields)
    this.zIndex = 200;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
